var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from 'react';
import { isOptionGroup } from './utils';
import { SelectBase } from './SelectBase';
var MultiSelect = function (_a) {
    var _b = _a.clearable, clearable = _b === void 0 ? true : _b, _c = _a.closeMenuOnSelect, closeMenuOnSelect = _c === void 0 ? false : _c, onChange = _a.onChange, _d = _a.options, options = _d === void 0 ? [] : _d, _e = _a.value, value = _e === void 0 ? [] : _e, _f = _a.selectionOrder, selectionOrder = _f === void 0 ? 'asSorted' : _f, rest = __rest(_a, ["clearable", "closeMenuOnSelect", "onChange", "options", "value", "selectionOrder"]);
    var handleChange = useCallback(function (options) {
        if (onChange) {
            onChange(options.map(function (option) { return option.value; }));
        }
    }, [onChange]);
    var flatOptions = useMemo(function () { return options.flatMap(function (opt) { return (isOptionGroup(opt) ? opt.options : opt); }); }, [options]);
    var selectedOptions = useMemo(function () {
        if (selectionOrder == 'asEntered') {
            /* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint */
            var isDefined = function (val) { return val !== undefined; };
            // filtering with respect to `value` will use the ordering of `value`. If the passer doesn't do any particular
            // sorting before passing `value`, then it will be ordered by the sequence that the user selected the items (due
            // to the behavior of react-select)
            return value.map(function (v) { return flatOptions.find(function (opt) { return opt.value === v; }); }).filter(isDefined);
        }
        else {
            // filtering with respect to `flatOptions` will use the ordering of `flatOptions`. e.g. if `options` is sorted
            // alphabetically, then the selectedOptions will also be returned in alphabetic order
            return flatOptions.filter(function (opt) { return value.includes(opt.value); });
        }
    }, [flatOptions, value, selectionOrder]);
    return (React.createElement(SelectBase, __assign({}, rest, { clearable: clearable, closeMenuOnSelect: closeMenuOnSelect, multiselect: true, onChange: handleChange, options: options, value: selectedOptions })));
};
export default MultiSelect;
//# sourceMappingURL=MultiSelect.js.map